const BMW = () => import('@/views/Partners/BMW.vue');
const BMWFR = () => import('@/views/Partners/BMW-fr.vue');
const EGolf = () => import('@/views/Partners/EGolf.vue');
const EGolfFR = () => import('@/views/Partners/EGolf-fr.vue');
const EtronPartner = () => import('@/views/Partners/Etron.vue');
const EtronPartnerFR = () => import('@/views/Partners/Etron-fr.vue');
const Porsche = () => import('@/views/Partners/Porsche.vue');
const PorscheFR = () => import('@/views/Partners/Porsche-fr.vue');
const VW = () => import('@/views/Partners/VW.vue');
const VWFR = () => import('@/views/Partners/VW-fr.vue');

const routes = [
  {
    path: '/bmw-i7/',
    name: 'bmw-i7-en',
    pathToRegexpOptions: { strict: true },
    component: BMW,
  },
  {
    path: '/fr/bmw-i7/',
    name: 'bmw-i7-fr',
    pathToRegexpOptions: { strict: true },
    component: BMWFR,
  },

  {
    path: '/e-golf/',
    name: 'e-golf-en',
    pathToRegexpOptions: { strict: true },
    component: EGolf,
  },
  {
    path: '/fr/e-golf/',
    name: 'e-golf-fr',
    pathToRegexpOptions: { strict: true },
    component: EGolfFR,
  },

  {
    path: '/e-tron/',
    name: 'e-tron-en',
    pathToRegexpOptions: { strict: true },
    component: EtronPartner,
    meta: {
      title: 'e-tron',
    },
  },
  {
    path: '/fr/e-tron/',
    name: 'e-tron-fr',
    pathToRegexpOptions: { strict: true },
    component: EtronPartnerFR,
    meta: {
      title: 'e-tron',
    },
  },

  {
    path: '/porsche/',
    name: 'porsche-en',
    pathToRegexpOptions: { strict: true },
    component: Porsche,
    meta: {
      title: 'Porsche',
    },
  },
  {
    path: '/fr/porsche/',
    name: 'porsche-fr',
    pathToRegexpOptions: { strict: true },
    component: PorscheFR,
    meta: {
      title: 'PorscheFR',
    },
  },

  {
    path: '/vw/',
    name: 'vw-en',
    pathToRegexpOptions: { strict: true },
    component: VW,
    meta: {
      title: 'VW',
    },
  },
  {
    path: '/fr/vw/',
    name: 'vw-fr',
    pathToRegexpOptions: { strict: true },
    component: VWFR,
    meta: {
      title: 'VW',
    },
  },
];
const exportedRoutes = routes;
export default exportedRoutes;
